module.exports = __webpack_public_path__ + "img/avatar.dd6b4441.png";